import { Skeleton } from '@redbubble/design-system';
import dynamic from 'next/dynamic';

export const DynamicSubscribeBannerFooter = dynamic(
  () =>
    import(
      /* webpackChunkName: "SubscribeBannerFooter" */
      './SubscribeBannerFooter'
    ).then(({ SubscribeBannerFooter: Component }) => Component),
  { ssr: false, loading: () => <Skeleton height="210px" animated /> }
);
